module.exports = __webpack_public_path__ + "static/img/2021.12-2022.11.a26b9ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/companyprofilepic/2021.12-2022.11.jpg
// module id = 3Zrl
// module chunks = 52